export default "__VITE_ASSET__DJJPJ5TK__"